module.exports = __webpack_public_path__ + "99c275c075bafddbce783ebfd08a3aab.svg";